//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import { getConfig } from '@/api/wx.js'
import config from '@/config/index'
import lawtopBanner from '@/assets/lawyer/banner-law.png'
import { getLawyerlist } from '@/api/lawyer'
import { getaddlog } from '@/api/hgfw'
export default {
  name: 'lawindex',
  data () {
    return {
      baseUrl: config.baseUrl,
      lawtopBanner: lawtopBanner,
      list: [],
      curObj: {},
      page: 1,
      rows: 10,
      select: 1
    }
  },
  created () {
    this.getlist()
    this.getAdd()
    this.wxconfig()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  methods: {
    // 添加浏览量
    getAdd () {
      getaddlog({
        accountid: this.accountid,
        moduleid: 1200,
        submoduleid: 120114
      }).then(res => {})
    },
    getlist () {
      getLawyerlist({
        page: this.page,
        rows: this.rows
      }).then(res => {
        if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
          this.list = res.returnValue.rows
          this.curObj = this.list[0]
        }
      })
    },
    goDetail (id) {
      this.$router.push({ name: 'lawyerDetail', params: { id: id } })
    },
    gomyask () {
      this.$router.push({ name: 'lawyerAsk' })
    },
    gosub (id) {
      this.$router.push({ name: 'lawyerSubmit', params: { id: id } })
    },
    // 微信权限配置
    wxconfig () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if (
        ua.match(/MicroMessenger/i) == 'micromessenger' &&
        ua.match(/wxwork/i) == 'wxwork'
      ) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = this.$store.state.user.wechatSignUrl
        // alert('微信客户端')
      }
      getConfig({
        url: href
      }).then(re => {
        var configs = re.returnValue
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configs.appId, // 必填，公众号的唯一标识
          timestamp: configs.timestamp, // 必填，生成签名的时间戳
          nonceStr: configs.nonceStr, // 必填，生成签名的随机串
          signature: configs.signature, // 必填，签名，见附录1
          jsApiList: ['previewImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      })
    },
    // 图片放大
    preview (index, fileList) {
      let arr = fileList.map(item => this.baseUrl + item.FILEPATH)
      wx.previewImage({
        current: arr[index], // 当前显示图片的http链接
        urls: arr // 需要预览的图片http链接列表
      })
    }
  }
}
